export default {
      id: "ui-arrow-top-right-usage",
      viewBox: "0 0 100 70",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#ui-arrow-top-right",
      toString: function () {
        return this.url;
      }
    }